import React from 'react'
import FfCancellation from '@/assets/icons/FfCancellation'
import FfDateChange from '@/assets/icons/FfDateChange'
import FfCabin from '@/assets/icons/FfCabin'
import FfSeatSelection from '@/assets/icons/FfSeatSelection'
import FfMealSelection from '@/assets/icons/FfMealSelection'
import FfCheckIn from '@/assets/icons/FfCheckIn'
import VrcIcon from '@/assets/svg/VrcIcon'
import { CANCEL, AMEND, SEAT, HAND_BAGGAGE, CHECK_IN_BAGGAGE, VISA_REJECTION_COVER } from '@/constants/fareFamily'


interface BenefitListIconProps {
    benefitKey: String
}

const BenefitListIcon = ({ benefitKey }: BenefitListIconProps) => {
    switch (benefitKey) {
        case HAND_BAGGAGE:
            return <FfCabin />
        case CHECK_IN_BAGGAGE:
            return <FfCheckIn />
        case CANCEL:
            return <FfCancellation />
        case AMEND:
            return <FfDateChange />
        case SEAT:
            return <FfSeatSelection />
        case VISA_REJECTION_COVER:
            return <VrcIcon />
        default:
            return <FfMealSelection />
    }
}

export default BenefitListIcon
